import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from "@material-ui/core/Grid";

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

function CircularIndeterminate(props) {
    const {classes} = props;
    return (
        <div>
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item>
                    <CircularProgress className={classes.progress} color="secondary"/>
                </Grid>
            </Grid>
        </div>
    );
}

CircularIndeterminate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CircularIndeterminate);